module.exports = "/_next/static/images/8578e8e60c7ad5bcddf4be0731e00f3d-roxinho-card-with-phone-lg@2x.jpg";